import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ContactHero from "../components/ContactHero";

const Contact = () => {
  return (
    <section>
      <Navbar />
      <ContactHero />
      <Footer />
    </section>
  );
};

export default Contact;
